// @ts-nocheck
import React, { useEffect } from "react";
import "leaflet/dist/leaflet.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhoneAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope, faEdit } from "@fortawesome/free-regular-svg-icons";
import "./SitePreview.css";
import SiteLogo from "../SiteLogo/SiteLogo";
import Map from "../Map/Map";
import { SiteMapPopup } from "../Map/Map";
import { t } from "i18next";
import { AsyncUsersList } from "components/Users/UsersList/UsersList";
import genRequest from "includes/request";
import useAccount from "classes/Accounts/hooks/useAccount";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import { useQueryClient } from "react-query";
import useSelect from "hooks/useSelect";

export default function SitePreview(props) {
	const { site } = props;
	const { isAdmin } = useAccount();
	const { confirmDelete } = useSelect();
	const QCL = useQueryClient();

	useEffect(() => {
		if (site?.id) {
			const url = new URL(window.location);
			url.searchParams.set('siteId', site.id);
			window.history.replaceState({}, '', url);
		}
	}, [site?.id]);

	let loc = props.site.localisation;
	let point;
	if (loc) {
		loc = loc.split(",");
		if (loc.length < 2)
			loc = false;
		else {
			point = {
				lat: parseFloat(loc[0]),
				lng: parseFloat(loc[1])
			};
		}
	}

	function handleDelete() {
		if (!site?.id)
			return (false);
		let title = t("Sites.ASKDELETE", {
			name: site.siteName,
			count: 1
		});
		confirmDelete(
			delSite,
			null,
			title
		);
	}

	function delSite() {
		if (!site.id)
			return (false)
		let req = genRequest(
			`sites/${site.id}`,
			null,
			"delete",
			{
				toast: true
			}
		).then(() => {
			QCL.resetQueries(["Sites"]);
			if (props.onDelete)
				props.onDelete();
		});
		return (req);
	}

	return (
		<div className="SitePreview">
			<div className="d-flex justify-content-between row align-items-start mb-3">
				<div className="site-identity">
					<SiteLogo className="me-3" imgAlt={[site.siteName, site.address, site.country].join("-")} site={site} siteId={site.id} companyId={site.companyId} />
					<div className="d-flex flex-wrap justify-content-between w-100 overflow-hidden">
						<div className="site-info d-flex flex-column">
							<div className="title font-bold mb-2">{site.siteName}</div>
							<div className="location mb-2">
								<div>{site.address}</div>
								{[site.postalCode, site.town].filter(a => a).join(" - ")}
								{site.country && <div>{site.country}</div>}
							</div>
							<div className="contacts">
								{!!site.mail?.length && <div className="site-mail"><a href={"mailto:" + site.mail}><FontAwesomeIcon className="site-contact-icon me-2" icon={faEnvelope} />{site.mail}</a></div>}
								{!!site.phone?.length && <div className="site-whatsapp"><a href={"whatsapp:" + site.phone}><FontAwesomeIcon className="site-contact-icon me-2" icon={faWhatsapp} />{site.phone}</a></div>}
								{!!site.phone?.length && <div className="site-phone"><a href={"tel:" + site.phone}><FontAwesomeIcon className="site-contact-icon me-2" icon={faPhoneAlt} />{site.phone}</a></div>}
							</div>
						</div>
					</div>
					{
						isAdmin() &&
						<div className="d-flex col-12 col-sm-4 order-0 order-sm-1 mb-2 mb-sm-0 justify-content-end gap-2 admin-menu">
							<div className="ms-auto btn btn-blue w-auto" onClick={props.handleModify}>
								{t("Commons.MODIFY")}
								<FontAwesomeIcon className="ms-2" icon={faEdit} />
							</div>
							<div className="btn btn-red w-auto" onClick={handleDelete}>
								{t("Commons.DELETE")}
								<FontAwesomeIcon className="ms-2" icon={faTrashAlt} />
							</div>
						</div>
					}
				</div>
			</div>
			{/* The wizard's end step previews values() (the request body, no id) */}
			{site?.id && <div className="mt-auto">
				<InfosFetcher
					className="nbr-member-txt"
					queryKey={["employees", "site", site.id]}
					queryFn={() => genRequest("employees/site/" + site.id)}
					treat={(infos) => {
						return (infos.length ? infos.length + ` ${t("Sites.MEMBERS")}` : false);
					}}
				/>
				<AsyncUsersList
					queryFn={() => genRequest("employees/site/" + site.id)}
					queryKey={["employees", "site", site.id]}
					max={10}
					width={40}
					className={"dark-bg fullviewUser"}
					fullView={true}
				/>
			</div>}
			{
				loc && point &&
				<div className="mt-2">
					<Map points={[point]} updateOnRefocus={false} popUp={<SiteMapPopup site={site} />} />
				</div>
			}
		</div>
	);
}
